<template lang="pug">
  .color-kit-hero.xs-12(v-if="product.id")
    .side-by-side-wrap.xs-12
      .back-to-advisor.xs-12.text-center
        template(v-if="bestMatch.code && product.code == bestMatch.code")
          p.xs-f-small.lg-f-medium.max-at-tweak Drumroll please, your&nbsp;
            a.underline(href="/color-advisor") quiz results
            |  are in...
        template(v-else-if="advisorComplete")
          p.xs-f-small.lg-f-medium.max-at-tweak Back to your&nbsp;
            a.underline(href="/color-advisor") quiz results

      .product-imagery.xs-12.md-7
        ColorKitImageryCarousel(:product="product")

      .product-info-and-cta.xs-12.md-5
        ColorKitInfo.xs-12(:product="product")
        BoostModule.xs-12
        ColorKitCTAs.xs-12(:product="product")
        NearColorBarCTA.xs-12

</template>

<script>
  import { mapState } from 'vuex';
  import vueQuizSvc from '../../../../services/vueQuizSvc';
  import ColorKitImageryCarousel from './ColorKitImageryCarousel';
  import ColorKitInfo from './ColorKitInfo';
  import BoostModule from './BoostModule';
  import ColorKitCTAs from './ColorKitCTAs';
  import NearColorBarCTA from './NearColorBarCTA';

  export default {
    name: "ColorKitHero",

    components: {
      ColorKitImageryCarousel,
      ColorKitInfo,
      BoostModule,
      ColorKitCTAs,
      NearColorBarCTA
    },

    data() {
      return {
        showHighlightsCTA: false
      }
    },

    computed: {
      ...mapState('pdp', ['product']),
      ...mapState('customer', ['cdata']),

      bestMatch() {
        return this.cdata.bestColorMatch || {};
      }
    },

    asyncComputed: {
      advisorComplete() {
        return vueQuizSvc.isQuizComplete({ name: 'advisor' }).then(res => res.data.isComplete);
      }
    }
  }
</script>

<style scoped lang="stylus">
  .color-kit-hero
    .side-by-side-wrap
      padding-top 1.5em
      padding-left 3%
      padding-right 3%
      
    .back-to-advisor
      padding-bottom 1.5em
            
    @media mq-tablet
      .product-info-and-cta
        padding-left 6%
        padding-right 6%
        
      .highlights-cta-wrap
        padding-left 5%
        padding-right 5%
        
      .product-bullets
        padding-left 10%
        padding-right 10%

    @media mq-desktop-md-plus
      .product-imagery
        padding-right 1em
        
      .product-bullets
        ul
          li
            width 24em
            
    @media mq-desktop-plus
      .product-bullets
        padding 1.5em 3%
        
        ul
          li
            width 25em
      
</style>
